import { render } from "./CastellsEdit-View.vue?vue&type=template&id=faa6c562"
import script from "./CastellsEdit-View.vue?vue&type=script&lang=js"
export * from "./CastellsEdit-View.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__